// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__29u9A","text":"SelectPayment_text__kAmkQ","title":"SelectPayment_title__3K1Rf","btn":"SelectPayment_btn__xmgDR"};